<div class="create-module-page">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">CREAR MÓDULO</h1>
                <p class="page-subtitle text-muted">
                    Registre un nuevo módulo completando la información básica, configuración de visualización y estado
                </p>
            </div>
        </div>
    </div>
    <div class="page-content">
        <mat-card class="form-card">

        <mat-card-content>
            <form [formGroup]="moduleForm" (ngSubmit)="onSubmit()">
                <!-- Información Básica -->
                <div class="form-section">
                    <h6 class="section-title d-flex align-items-center mb-3">
                        <i class="ri-information-line me-2 text-primary"></i>
                        Información Básica
                    </h6>
                    
                <div class="form-grid basic-grid">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Código</mat-label>
                            <input matInput formControlName="code" placeholder="liquidaciones-vd" inputmode="text">
                            <mat-error *ngIf="moduleForm.get('code')?.hasError('required')">
                                {{ getErrorMessage('code') }}
                            </mat-error>
                            <mat-error *ngIf="moduleForm.get('code')?.hasError('maxlength')">
                                {{ getErrorMessage('code') }}
                            </mat-error>
                            <mat-hint>Código único del módulo (usado para identificación interna)</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Nombre</mat-label>
                            <input matInput formControlName="name" placeholder="Liquidaciones VD" inputmode="text">
                            <mat-error *ngIf="moduleForm.get('name')?.hasError('required')">
                                {{ getErrorMessage('name') }}
                            </mat-error>
                            <mat-error *ngIf="moduleForm.get('name')?.hasError('maxlength')">
                                {{ getErrorMessage('name') }}
                            </mat-error>
                            <mat-hint>Nombre que se mostrará en el menú</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field full-width">
                            <mat-label>Descripción</mat-label>
                            <textarea matInput formControlName="description" rows="3" placeholder="Descripción del módulo" inputmode="text"></textarea>
                            <mat-error *ngIf="moduleForm.get('description')?.hasError('maxlength')">
                                {{ getErrorMessage('description') }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Configuración de Visualización -->
                <div class="form-section">
                    <h6 class="section-title d-flex align-items-center mb-3">
                        <i class="ri-eye-line me-2 text-primary"></i>
                        Configuración de Visualización
                    </h6>
                    
                    <div class="form-grid display-grid">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Ruta</mat-label>
                            <input matInput formControlName="route" placeholder="/under-construction" inputmode="text">
                            <mat-error *ngIf="moduleForm.get('route')?.hasError('maxlength')">
                                {{ getErrorMessage('route') }}
                            </mat-error>
                            <mat-hint>Ruta del módulo en la aplicación</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Ícono</mat-label>
                            <mat-select formControlName="icon" placeholder="Seleccione un ícono">
                                <mat-option *ngFor="let icon of availableIcons" [value]="icon">
                                    <div class="d-flex align-items-center">
                                        <i-feather *ngIf="!icon.startsWith('mat:')" [name]="icon" class="me-3" style="width: 18px; height: 18px;"></i-feather>
                                        <span *ngIf="icon.startsWith('mat:')" class="material-symbols-outlined me-3" style="font-size: 18px;">{{ icon.slice(4) }}</span>
                                        <span>&nbsp;{{ icon.startsWith('mat:') ? icon.slice(4) : icon }}</span>
                                    </div>
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="moduleForm.get('icon')?.hasError('maxlength')">
                                {{ getErrorMessage('icon') }}
                            </mat-error>
                            <mat-hint>Seleccione un ícono de feather icons</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Orden</mat-label>
                            <input matInput formControlName="order" type="number" min="0" inputmode="numeric">
                            <mat-error *ngIf="moduleForm.get('order')?.hasError('required')">
                                {{ getErrorMessage('order') }}
                            </mat-error>
                            <mat-error *ngIf="moduleForm.get('order')?.hasError('min')">
                                {{ getErrorMessage('order') }}
                            </mat-error>
                            <mat-hint>Orden de visualización en el menú</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Grupo de Menú</mat-label>
                            <mat-select formControlName="menuGroup" placeholder="Seleccione un grupo">
                                <mat-option [value]="null">Sin Grupo</mat-option>
                                <mat-option *ngFor="let group of menuGroups" [value]="group.nombre">
                                    {{ group.nombre }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="moduleForm.get('menuGroup')?.hasError('maxlength')">
                                {{ getErrorMessage('menuGroup') }}
                            </mat-error>
                            <mat-hint>Grupo al que pertenece el módulo (opcional)</mat-hint>
                        </mat-form-field>

                        <div class="form-field checkbox-field">
                            <mat-checkbox formControlName="isActive" color="primary">
                                Módulo Activo
                            </mat-checkbox>
                        </div>
                    </div>
                </div>

                <!-- Botones de acción -->
                <div class="form-actions">
                    <button type="button" mat-button (click)="onCancel()" [disabled]="isLoading">
                        <i class="ri-arrow-left-line me-2"></i>
                        Cancelar
                    </button>
                    <button type="submit" mat-raised-button color="primary" [disabled]="moduleForm.invalid || isLoading">
                        <span *ngIf="!isLoading">
                            <i class="ri-add-line me-2"></i>
                            Crear Módulo
                        </span>
                        <span *ngIf="isLoading">
                            <i class="ri-loader-4-line animate-spin me-2"></i>
                            Creando...
                        </span>
                    </button>
                </div>
            </form>
        </mat-card-content>
        </mat-card>
    </div>
</div>

